/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react";
import { observer } from "mobx-react";
import { ContactSearchTableContext } from "./ContactSearchTable";
import { formatDiscoverTotalDisplay } from "../DataSearchUtils";

const ContactsFound = () => {
  const { contactData = {} } = useContext(ContactSearchTableContext);

  let totalCount = contactData?.totalContacts || 0;

  const getText = () => {
    const formattedCount = formatDiscoverTotalDisplay(totalCount);
    return (
      <div>
        <span style={{ color: "#3953fb" }}>{formattedCount}</span> {totalCount === 1 ? "result" : "results"}
      </div>
    );
  };

  return totalCount > 0 && <div className="contactsFound">{getText()}</div>;
};

export { ContactsFound };
export default observer(ContactsFound);
